import { useAppSelector } from '@/store/hooks'
import { getEnabledFeatures } from '@/store/selectors'

export default function useFeatures() {
  return useAppSelector(getEnabledFeatures)
}
